/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsOrphanedSystemResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsOrphanedSystemResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsOrphanedSystemResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsOrphanedSystemResource>): RecommendationForFinopsOrphanedSystemResource {
        let obj = Object.assign(new RecommendationForFinopsOrphanedSystemResource(), model);
        RecommendationForFinopsOrphanedSystemResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsOrphanedSystemResource>): RecommendationForFinopsOrphanedSystemResource {
        if (!model) return null;
        return RecommendationForFinopsOrphanedSystemResource.newInstance(<RecommendationForFinopsOrphanedSystemResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsOrphanedSystemResource) {
        if (!obj) return;

        models.RecommendationForFinopsOrphanedSystemResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsOrphanedSystemResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsOrphanedSystemResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
